import type { SxProps, Theme } from "@mui/material";

export const MOBILE_SHEET_FOOTER_BUTTON_GAP = 1.25;

export const mobileSheetCancelButtonSx: SxProps<Theme> = {
  borderRadius: 2,
  textTransform: "none",
  fontWeight: 600,
};

export const mobileSheetConfirmButtonSx: SxProps<Theme> = {
  borderRadius: 2,
  textTransform: "none",
  fontWeight: 700,
};
